import moment from 'moment'

export default (date: string, format: string): string => {
    return moment(date).format(format)
}
